import { Button, Card, CardBody, Col, CardHeader, Container, Form, FormGroup, Input, Label, Row, Table, CardFooter, Media, Alert } from "reactstrap";
import { Btn, H4, Image, LI, P, UL, Badges, H3, H5, SVG, H1, Alerts, H2 } from "../../../AbstractElements";
// import {   URL_API } from "../../../utils/Constant";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import useFourListe from "../../Fournisseurs/FourApi";
import { ActualFileUpload, DropFileUploadText, DropFilesHereOrClickToUpload, UploadProjectFiles } from'../../../utils/Constant';
import { Dropzone, FileMosaic, ExtFile } from "@dropzone-ui/react";
import { H6 } from '../../../AbstractElements';
import useInfosEts from "../../InfosEts/InfoApi";
import SweetAlert from 'sweetalert2';
import Formulaires from "./formulaire";
// import AddVersementDiamond from "./addDiamond";
// import AddVersementCimaf from "./addCimaf";
// import AddCimentsDeGuinee from "./addCimentsDeGuinee";

type Fourniss = { [key: string]: any }

const AddAutresVersements = () => {

    const [selectType, setSelectType] = useState('')
    const [idFournisseur, setIdFournisseur] = useState<number>()
    const [refresh, setRefresh] = useState(false)
    const fournisseur = useFourListe(refresh)

    const selectFournisseur = ({ id, type }: { id: number, type: string }) => {
        setSelectType(type);
        setIdFournisseur(id);
    }

    useEffect(() => {

    }, [idFournisseur, selectType])

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Ajouter" parent="Versements" />
            <Container fluid>

                {
                    fournisseur.length > 0 ? (
                        <>
                            <Row>
                                {
                                    fournisseur.map((item, index) => {
                                        if(item.type === 'diamond' || item.type === 'diamond_sougueta'){
                                            return (
                                                <Col sm={6}>
                                                <Card className={`progress-items pb-0 ${selectType == item.type ? 'bg-light-success' : 'bg-light-info'}`} key={index} onClick={() => selectFournisseur({ id: item.id, type: item.type })}>
                                                    <CardHeader className={`pb-4 ${selectType == item.type ? 'bg-light-success' : 'bg-light-info'}`}>
                                                        <Link to={'#'} className="text-dark">
    
                                                            <H5 className="text-center">
                                                                <span className="text-dark fw-bold">{item.name}</span>
                                                            </H5>
                                                        </Link>
                                                    </CardHeader>
                                                </Card>
                                            </Col>
                                            )
                                        }
                                    })
                                }
                            </Row>
                            {
                                selectType == 'diamond' ? (
                                    <Formulaires id_fournisseur={idFournisseur ?? 0} type={selectType} />
                                ) : selectType == 'diamond_sougueta' ? (
                                    <Formulaires id_fournisseur={idFournisseur ?? 0} type={selectType} />
                                ) : (
                                    <Alert color="light-dark" className="text-center">
                                        <H2>Veuillez Selectionner Une Usine</H2>
                                    </Alert>
                                )
                            }
                        </>

                    ) : (
                        <Alert color="info" className="text-center" timeou>
                            <h5 className="text-white text-uppercase text-white fw-bold">Aucun fournisseur enrégistré, Veuillez enrégistrer les fournisseurs</h5>
                        </Alert>
                    )
                }
            </Container>
        </div >
    )
}

export default AddAutresVersements;